// extracted by mini-css-extract-plugin
module.exports = {"major":"Major_major__tvLrM"};